import { EVALUATION_STATES, EVALUATION_STORAGE_KEYS, LAST_SELECTED_SECTION, REPEAT_USER_COOKIE_NAME, SELLER_STATE_COOKIE, USER_INTENT_COOKIE, TAB_NAME, USER_TAB_COOKIE } from "../Constants/evaluation";
import CookieManager from "./CookieManager";
import { getDateFromSlotDetails, getMidnightDate, isDatePassed } from "./DateHelper";
import LocalStorageHelper from "./LocalStorageHelper";
import SessionStorageHelper from "./SessionStorageHelper";
var VALUATION_USER_VALUES = EVALUATION_STORAGE_KEYS.VALUATION_USER_VALUES,
  VALUATION_PREDICTED_PRICE = EVALUATION_STORAGE_KEYS.VALUATION_PREDICTED_PRICE,
  APPOINTMENT_DETAILS = EVALUATION_STORAGE_KEYS.APPOINTMENT_DETAILS,
  VALUATION_DATA_VALUES = EVALUATION_STORAGE_KEYS.VALUATION_DATA_VALUES;
export var MS_TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;
export var ABUNDANCE_COUNT = 'AC';
var UserSession = {
  initUserVisitStatus: function initUserVisitStatus() {
    var cookieVal = CookieManager.readCookie(REPEAT_USER_COOKIE_NAME);
    if (!cookieVal) {
      CookieManager.createCookie(REPEAT_USER_COOKIE_NAME, 'true');
    }
  },
  isRepeatUser: function isRepeatUser() {
    var cookieVal = CookieManager.readCookie(REPEAT_USER_COOKIE_NAME);
    return !!cookieVal;
  },
  saveUserEvaluationFormValues: function saveUserEvaluationFormValues(userValues, isValuationFlowPage) {
    LocalStorageHelper.setItem(VALUATION_USER_VALUES, JSON.stringify(userValues));
    if (isValuationFlowPage) {
      UserSession.setUserEvaluationState(EVALUATION_STATES.VALUATION_STARTED);
    }
    CookieManager.createCookie(REPEAT_USER_COOKIE_NAME, 'true');
  },
  deleteEvaluationFormValues: function deleteEvaluationFormValues() {
    LocalStorageHelper.removeItem(VALUATION_USER_VALUES);
    CookieManager.eraseCookie(SELLER_STATE_COOKIE);
  },
  getLastSelectionOption: function getLastSelectionOption() {
    var option = LocalStorageHelper.getItem(LAST_SELECTED_SECTION);
    if (option) {
      return option;
    }
    return null;
  },
  saveLastSelectionOption: function saveLastSelectionOption(option) {
    LocalStorageHelper.setItem(LAST_SELECTED_SECTION, option);
  },
  deleteLastSelectionOption: function deleteLastSelectionOption() {
    LocalStorageHelper.removeItem(LAST_SELECTED_SECTION);
  },
  getUserEvaluationFormValues: function getUserEvaluationFormValues() {
    var userValues = LocalStorageHelper.getItem(VALUATION_USER_VALUES);
    if (userValues) {
      return JSON.parse(userValues);
    }
    return null;
  },
  handleNoPredictedPriceFound: function handleNoPredictedPriceFound() {
    CookieManager.createCookie(SELLER_STATE_COOKIE, EVALUATION_STATES.VALUATION_ERROR, 0, true, true);
  },
  saveEvaluationPredictedPrice: function saveEvaluationPredictedPrice(evaluationPrice) {
    var _a, _b;
    LocalStorageHelper.setItem(VALUATION_PREDICTED_PRICE, JSON.stringify(evaluationPrice));
    var lengthOfPredictions = evaluationPrice && ((_b = (_a = evaluationPrice === null || evaluationPrice === void 0 ? void 0 : evaluationPrice.predictions) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.length);
    if (lengthOfPredictions) {
      var expiryDays = 15;
      if (evaluationPrice.limit && !evaluationPrice.limit.buyable) {
        UserSession.setUserEvaluationState(EVALUATION_STATES.VALUATION_BEYOND_LIMIT, expiryDays);
      } else {
        UserSession.setUserEvaluationState(EVALUATION_STATES.VALUATION_DONE, expiryDays);
      }
      CookieManager.createCookie(REPEAT_USER_COOKIE_NAME, 'true');
    } else {
      UserSession.handleNoPredictedPriceFound();
    }
  },
  deleteEvaluationPredictedPrice: function deleteEvaluationPredictedPrice() {
    LocalStorageHelper.removeItem(VALUATION_PREDICTED_PRICE);
    CookieManager.eraseCookie(SELLER_STATE_COOKIE);
  },
  getEvaluationPredictedPrice: function getEvaluationPredictedPrice() {
    var evaluationPrice = LocalStorageHelper.getItem(VALUATION_PREDICTED_PRICE);
    if (evaluationPrice) {
      return JSON.parse(evaluationPrice);
    }
    return null;
  },
  saveAppointmentDetails: function saveAppointmentDetails(appointmentDetails) {
    LocalStorageHelper.setItem(APPOINTMENT_DETAILS, JSON.stringify(appointmentDetails));
    var slotDetails = appointmentDetails.slotDetails;
    var date = getDateFromSlotDetails(slotDetails);
    date.setTime(date.getTime() + MS_TWENTY_FOUR_HOURS);
    CookieManager.createCookie(SELLER_STATE_COOKIE, EVALUATION_STATES.APPOINTMENT_CREATED, 0, true, false, getMidnightDate(date));
  },
  deleteAppointmentDetails: function deleteAppointmentDetails() {
    LocalStorageHelper.removeItem(APPOINTMENT_DETAILS);
    CookieManager.eraseCookie(SELLER_STATE_COOKIE);
  },
  getAppointmentDetails: function getAppointmentDetails() {
    var appointmentDetailsString = LocalStorageHelper.getItem(APPOINTMENT_DETAILS);
    if (appointmentDetailsString) {
      var appointmentDetails = JSON.parse(appointmentDetailsString);
      var slotDetails = appointmentDetails.slotDetails;
      var date = getDateFromSlotDetails(slotDetails);
      if (isDatePassed(date)) {
        UserSession.deleteAppointmentDetails();
      }
      return appointmentDetails;
    }
    return null;
  },
  setUserEvaluationState: function setUserEvaluationState(state, days) {
    CookieManager.createCookie(SELLER_STATE_COOKIE, state, days);
  },
  getUserEvaluationState: function getUserEvaluationState() {
    var value = CookieManager.readCookie(SELLER_STATE_COOKIE);
    return value || EVALUATION_STATES.INITIAL;
  },
  setUserIntent: function setUserIntent(intent) {
    CookieManager.createCookie(USER_INTENT_COOKIE, intent);
  },
  setTabName: function setTabName(tabName) {
    CookieManager.createCookie(USER_TAB_COOKIE, tabName);
  },
  getTabName: function getTabName() {
    var value = CookieManager.readCookie(USER_TAB_COOKIE);
    return value || TAB_NAME.INITIAL;
  },
  getUserIntent: function getUserIntent() {
    var value = CookieManager.readCookie(USER_INTENT_COOKIE);
    return value;
  },
  saveValuationDataValues: function saveValuationDataValues(userValues) {
    LocalStorageHelper.setItem(VALUATION_DATA_VALUES, JSON.stringify(userValues));
  },
  setAdundanceCount: function setAdundanceCount(count) {
    SessionStorageHelper.setItem(ABUNDANCE_COUNT, JSON.stringify(count));
  }
};
export default UserSession;